import * as React from "react";

type Handler<T = any> = (data?: T) => void;

class Subscription {
    constructor(public readonly event: string, public handler: Handler) {}
    handle = (data?: any) => {
        this.handler(data);
    };

    destruct = () => {
        this.handler = undefined;
    };
}

class Mediator {
    private subscribers: Subscription[] = [];
    private _id: string;

    constructor() {
        this._id = Date.now().toString();
    }

    public subscribe = <T>(event: string, handler: Handler<T>) => {
        const sub = new Subscription(event, handler);
        this.subscribers.push(sub);
        return sub;
    };

    public send = (event: string, data?: any) => {
        this.subscribers
            .filter(s => s.event === event)
            .forEach(s => s.handle(data));
    };

    public unsubscribe = (subscription: Subscription) => {
        for (let i = 0; i < this.subscribers.length; i++) {
            if (this.subscribers[i] === subscription) {
                this.subscribers[i].destruct();
                this.subscribers.splice(i, 1);
                return;
            }
        }
    };

    public clearEvents = (eventName: string | "ALL") => {
        if (eventName === "ALL") {
            this.subscribers.forEach(s => (s.handle = undefined));
            this.subscribers = [];
            return;
        }

        for (let i; i < this.subscribers.length; i++) {
            if (
                this.subscribers[i].event === eventName ||
                eventName === "ALL"
            ) {
                this.subscribers[i].destruct();
                this.subscribers.splice(i, 1);
                return;
            }
        }
    };
}

export const mediator = new Mediator();

export const useMediator = <T>(event: string, handler: Handler) => {
    React.useEffect(() => {
        const sub = mediator.subscribe(event, handler);
        return () => mediator.unsubscribe(sub);
    }, [event, handler]);
};
